import { makeStyles } from "@material-ui/styles";
import React from "react";
import {
  IPlannerLabel,
  IPlannerMinute,
  ITripPlanner,
  ITimelineCommand,
  ITripPlannerEstimateResponse,
  TimelineCommandType,
  Iuser,
  ServicedBy
} from "../types/plannerTypes";
import { prepareTimelineLabels } from "./plannerHelpers";
import { IPlannerState } from "../../../store/modules/plannerSlice";
import TimelineMinutes from "./TimelineMinutes";
import PlannerTimelineLayers from "./PlannerTimelineLayers";
import PlannerTimelineLoading from "./PlannerTimelineLoading";
import { useDispatch } from "react-redux";

import { getPlannerLoading } from "./plannerHelpers";
import { applyCommandToVirtualTrip, applyVirtualTripEstimate, createTripPlannerEstimateRequest, prepareNewLocalState } from "./virtualTripHelpers";
import api from "../../../store/api";
import { checkConflictsForUpdatedTrip } from "../conflictNotices/conflictNoticeHelper";
import { applyLocalChangesForTimeline } from "../../../store/modules/plannerSlice";
import { IVirtualTrip } from "../../../common/plannerTypes";
import { setLoading } from "../../../store/modules/plannerLoadingSlice";

interface PlannerTimelineProps {
  selectedLocationId: string;
  selectedDay: string;
  plannerStore: IPlannerState;
  tripPlanner: ITripPlanner;
  setErrorMessage: any;
  setConflictDialogData: any;
  showAdHocRequestModal: any;
  blockLabel: string | null;
  roles: any;
}


const timelineHeight = 90;
const hourLabelHeight = 30;

const useStyles = makeStyles((theme) => ({
  timelineWrapper: {
    position: "relative",
    height: 90,
  },
  hourLabel: {
    display: "flex",
    justifyContent: "center",
    marginTop: 5,
    marginBottom: 5,
    flex: "2",

    "&:first-child": {
      flex: "1",
    },
    "&:last-child": {
      flex: "1",
    },
  },
  timeLineLablesWrapper: {
    display: "flex",
    height: timelineHeight,
    zIndex: 30,
    width: "100%",
    background: "#02489D",
    flexDirection: "column",
    overflow: "hidden",
  },
  cusTimeLineLablesWrapper: {
    display: "flex",
    height: timelineHeight,
    zIndex: 30,
    width: "100%",
    background: "#552D7C",
    flexDirection: "column",
    overflow: "hidden",
  },
  timeLineLables: {
    display: "flex",
    height: hourLabelHeight,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    zIndex: 1100,
  },
}));

const PlannerTimeline: React.FC<PlannerTimelineProps> = (props: any) => {
  const { selectedLocationId, selectedDay, tripPlanner, plannerStore, setErrorMessage, setConflictDialogData, blockLabel, showAdHocRequestModal,roles } =
    props;
  //console.log(tripPlanner);
  //console.log("Transferstrip");
  const classes = useStyles();
  const dispatch = useDispatch();

  const [timelineContent, setTimelineContent] = React.useState<IPlannerMinute[]>([]);
  const [timelineLabels, setTimelineLabels] = React.useState<IPlannerLabel[]>(prepareTimelineLabels(tripPlanner, selectedDay));
  const [userDetails, setUserDetails] = React.useState("");
  React.useEffect(() => {
    setTimelineLabels(prepareTimelineLabels(tripPlanner, selectedDay));
    api.getCurrentUserDetails("").then(_res => {
      if (_res !== null && _res.data.model !== null) {
        setUserDetails(_res.data.model.userId);
      }
    }).catch(error => {
      setErrorMessage('Error while getting user details');
    });
  }, [tripPlanner, selectedDay]);

  // droppedTrip is trip which was dropped or choosen for update
  const applyTimelineChanges = React.useCallback(
    async (droppedTrip: IVirtualTrip, timelineCommand: ITimelineCommand) => {
      try {

        if (getPlannerLoading()) {
          throw "Previous timeline update not finished";
        }
        setErrorMessage("");

        if (timelineCommand.trasferIdForRemoving != null) {
          const idxremovetr = droppedTrip?.transfers.findIndex((tr) => tr.transferId === timelineCommand.trasferIdForRemoving);
          const transfers = droppedTrip?.transfers[idxremovetr]
          let status = transfers?.scheduleObj?.status
          if (status == 4)//Completed
          {
            throw "This transfer is Completed and can no longer be modified";
          }
        }



        // prepare new desired state of virtual trip (virtualTripId can change on this step)
        const virtualTripRequest = applyCommandToVirtualTrip(droppedTrip, timelineCommand);

        let newLocalStateRequest: IVirtualTrip[] = [...plannerStore.localState];
        const _multiload = newLocalStateRequest.filter(q=>q.isMultiLoaded === true);
        // if trip without transfers -> it should be ignored
        if (!virtualTripRequest.ignoreResultTrip) {
          dispatch(setLoading(true));

          const req = createTripPlannerEstimateRequest(virtualTripRequest.resultTrip, selectedLocationId);
          let isReArranged = localStorage.getItem("isReArranged");
          if (isReArranged == null || isReArranged == undefined) {
            isReArranged = "false";
          }

          const res = await api.estimateVirtualTrip(`isRearranged=${isReArranged}` + `&Type=${timelineCommand.type ? timelineCommand.type : ''}` + `&isMultiload=${droppedTrip.isMultiLoaded}`, req);
          if (res.hasError) throw res.message;

          const estimateResponse: ITripPlannerEstimateResponse = res;
          if (estimateResponse.tripDuration) {
            // get updated virtual trip using desired state

            const updatedVirtualTrip = applyVirtualTripEstimate(virtualTripRequest.resultTrip, estimateResponse);

            newLocalStateRequest = prepareNewLocalState(plannerStore.localState, droppedTrip, timelineCommand.tripUpdates, updatedVirtualTrip);
            // check conflicts
            const timelineVisualState = plannerStore.visualState.filter(
              (v: any) =>
                v.tripPlannerId == tripPlanner.tripPlannerId &&
                v.virtualTripId !== droppedTrip.virtualTripId &&
                v.virtualTripId !== virtualTripRequest.resultTrip.virtualTripId
            );

            setConflictDialogData(checkConflictsForUpdatedTrip(selectedDay, tripPlanner, timelineVisualState, updatedVirtualTrip,userDetails));

            dispatch(setLoading(false));
          } else {
            throw "Something wrong with trip status or estimate";
          }
        }
        // add a removed trip
        if (virtualTripRequest.freedTripAfterRemoving) {
          if (_multiload.length === 0 && timelineCommand.type !== TimelineCommandType.removeFromTrip) {
            newLocalStateRequest = [];
          }
          if(virtualTripRequest.resultTrip.tripPlannerId){
            newLocalStateRequest.push(virtualTripRequest.freedTripAfterRemoving);
          }
        }

        // apply local state changes
        dispatch(
          applyLocalChangesForTimeline({
            tripPlannerId: tripPlanner.tripPlannerId,
            updatedState: newLocalStateRequest
          })
        );
      } catch (error) {
        setErrorMessage(error); //"Error while applying timeline changes");
        console.error(error);
        dispatch(setLoading(false));
      }
    },
    [plannerStore]
  );

  return (
    <>
      <PlannerTimelineLoading />
      <div className={classes.timelineWrapper}>
        <div className={tripPlanner.servicedBy==ServicedBy.SMA ? classes.timeLineLablesWrapper:classes.cusTimeLineLablesWrapper}>
          <div className={classes.timeLineLables}>
            {timelineLabels.map((h, index) => (
              <div className={classes.hourLabel} key={index}>
                {h.hourStr}
              </div>
            ))}
          </div>
          <TimelineMinutes
            selectedDay={selectedDay}
            tripPlanner={tripPlanner}
            plannerStore={plannerStore}
            setErrorMessage={setErrorMessage}
            setConflictDialogData={setConflictDialogData}
            timelineContent={timelineContent}
            setTimelineContent={setTimelineContent}
            blockLabel={blockLabel}
            applyTimelineChanges={applyTimelineChanges}
            showAdHocRequestModal={showAdHocRequestModal}
            userid={userDetails}
            roles={roles}
            selectedLocationId ={selectedLocationId}
          />
        </div>
        <PlannerTimelineLayers
          selectedDay={selectedDay}
          tripPlanner={tripPlanner}
          plannerStore={plannerStore}
          blockLabel={blockLabel}
          timelineContent={timelineContent}
          setTimelineContent={setTimelineContent}
          applyTimelineChanges={applyTimelineChanges}
          setErrorMessage = {setErrorMessage}
        />
      </div>
    </>
  );
};
export default React.memo(PlannerTimeline);
